export default "<p>\r\n  dashboard works!\r\n</p>\r\n";